
  
     
<script>
import lazyLoadComponent from '@router/lazyload-component'
import analyticsDateValidateMixin from '@src/mixins/analyticsDateValidateMixin'
import pageMixin from '@src/mixins/pagination'
import incomeMixin from '@src/mixins/income'
import formatDate, { formatRequestData } from '@utils/format-date'

export default {
  page: {
    title: '銷售',
    meta: [{ name: 'description', content: 'Customer Analytics' }],
  },
  components: {},
  mixins: [pageMixin, incomeMixin, analyticsDateValidateMixin],
  props: {
    merchantProducts: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      filterData: {
        startDate: '',
        endDate: '',
        unit: 'week',
        productId: '',
        type: 'serviceAdd',
        petCategoryId: '',
        petSizeId: '',
      },
      categoryList: [],
      sales: {},
      dateGroup: [],
      activeDate: '',
      activeDateIndex: 0,
      dateRangeMode: 'month',
      dateNow: '',
      activeCellData: '',
      showMode: 'total',
      pageNum: 0,
      tryingFetch: false,
      tryingFetchTime: false,
      showSum: true,
      tryingToExport: false
    }
  },
  computed: {
    forShowColumnListFilter() {
      let list = JSON.parse(JSON.stringify(this.columnIncomeShowList))
      if (!this.$hasDeposit()) {
        list = list.filter(item => item.value !== 'depositTotal')
      }
      // 如果沒有開通線上金流，則filter線上系列
      if (!this.$cashFlowSettingPass()) {
        list = list.filter(item => item.value !== 'creditTotal' && item.value !== 'vaccTotal')
      }
      // 目前僅自燃派開放中租，其他店家filter中租
      if(this.$store.state.merchant.cached.alias !== 'naturalpan') {
        list = list.filter(item => item.value !== 'chaileaseTotal')
      }
      return list.filter(item => item.value !== 'prepaidTotal')
    },
    activeSizeList() {
      let active = []
      if (this.filterData.petCategoryId) {
        active = this.categoryList.find((item) => {
          return item.id === this.filterData.petCategoryId
        }).children
      } else {
        active = []
      }
      return active
    },
    filterDateRange: {
      get() {
        return [this.filterData.startDate, this.filterData.endDate]
      },
      set(value) {
        const [start, end] = value || ['', '']
        this.filterData.startDate = start
        this.filterData.endDate = end
      },
    },
    fetchDataParams() {
      const routeQuery = this.$route.query
      const queryData = Object.assign(routeQuery, this.pageQuery)
      const { startDate, endDate, ...filterDataWithoutDate } = this.filterData
      const searchWithDate = startDate && endDate
      const searchParams = searchWithDate
        ? Object.assign(this.filterData, {
          startDate: formatRequestData(startDate),
          endDate: formatRequestData(endDate),
        })
        : filterDataWithoutDate
      return Object.assign(searchParams, queryData)
    },
  },
  watch: {
    filterDateRange(value) {
      if (this.filterDateRange[0] === undefined) {
        this.dateRangeMode = ''
        return
      }
      const time = (new Date(this.filterDateRange[1]).getTime() / 1000 - new Date(this.filterDateRange[0]).getTime() / 1000) / 86400
      const todayRange = Math.floor(new Date().getTime() / 1000 / 86400) - new Date(this.filterDateRange[0]).getTime() / 1000 / 86400
      switch (true) {
        case time >= 0 && time <= 7:
          this.dateRangeMode = 'day'
          this.filterData.unit = 'day'
          break
        case time > 7 && time < 30:
          this.dateRangeMode = 'week'
          this.filterData.unit = 'day'
          break
        case time >= 30 && time < 364:
          this.dateRangeMode = 'month'
          this.filterData.unit = 'week'
          break
        case time >= 365:
          this.dateRangeMode = 'year'
          this.filterData.unit = 'quarter'
          break
      }
      switch (true) {
        case todayRange === 0:
          this.dateNow = 'day'
          break
        case todayRange === 30:
          this.dateNow = 'month'
          break
        default:
          this.dateNow = ''
      }
    },
    showMode() {
      this.showSum = false
      this.$nextTick(() => {
        this.showSum = true
      })
    },
    'filterData.unit': function () {
      this.activeDateIndex = 0
      this.activeDate = this.dateGroup[this.activeDateIndex]
    },
    'filterData.petCategoryId': function (value) {
      this.filterData.petSizeId = ""
    },
  },
  created() {
    this.getDefaultDate()
    this.tryToFetchList()
    this.tryToFetchCategory()
  },
  methods: {
    getDefaultDate() {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      this.filterData.startDate = `${start.getFullYear()}/${start.getMonth() + 1}/${start.getDate()}`
      this.filterData.endDate = `${end.getFullYear()}/${end.getMonth() + 1}/${end.getDate()}`
    },
    async tryToFetchCategory() {
      this.categoryList = await this.$store.dispatch('product/fetchServiceCategory', { paginate: 0 })
    },
    async tryToFetchList(isChangeTime) {

      this.tryingFetch = true
      this.tryingFetchTime = true
      this.sales = await this.$store.dispatch('analytics/fetchSales', this.fetchDataParams)
      this.dateGroup = Object.keys(this.sales)
      this.activeDateIndex = 0
      this.activeDate = this.dateGroup[this.activeDateIndex]

      // this.sales = items
      this.tryingFetch = false
      this.tryingFetchTime = false

      // this.pageNum = 0
      // this.visibleDetail = true
      // this.tryingFetchDetail = false
    },
    async tryToFetchListUnit() {
      this.tryingFetchTime = true
      this.sales = await this.$store.dispatch('analytics/fetchSales', this.fetchDataParams)
      this.tryingFetchTime = false
      this.dateGroup = Object.keys(this.sales)
      this.activeDateIndex = 0
      this.activeDate = this.dateGroup[this.activeDateIndex]
    },
    changeMode(valve) {
      this.dateRangeMode = valve
    },
    reset() {
      // this.filterDateRange = []
      this.getDefaultDate()
      this.dateRangeMode = 'month'
      this.filterData.unit = 'week'
      this.tryToFetchList()
    },
    selectData(value) {
      this.activeCellData = value
      this.changeCellClass()
    },
    deleteYear(item) {
      const year = new Date().getFullYear()
      if (this.filterData.unit === 'quarter' || this.filterData.unit === 'month') {
        return item
      } else {
        const reg = new RegExp(`${year}-`, 'g')
        const regSpace = new RegExp('-', 'g')
        item = item.replace(reg, '')
        item = item.replace(regSpace, '/')
        return item
      }
    },
    changeGroup(isPlus) {
      if (isPlus) {
        this.activeDateIndex++
        this.activeDate = this.dateGroup[this.activeDateIndex]
      } else {
        this.activeDateIndex--
        this.activeDate = this.dateGroup[this.activeDateIndex]
      }
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '加總';
          return;
        }
        if (index === 1) {
          sums[index] = '全部分店';
          return;
        }
        const values = data.map(item => Number(item.items[index - 2][this.forShowColumnInSelect]));

        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = this.showMode === 'total' ? '$' + sums[index] : sums[index];
        } else {
          sums[index] = 'N/A';
        }
      });

      return sums;
    },
    async handleExport() {
      if (this.tryingToExport) return
      this.tryingToExport = true
      const request = {
        analyticsType: 'sales',
        submitData: {
          ...this.fetchDataParams,
          export: 1,
          count: this.showMode === 'orders' ? 1 : 0

        }
      }
      const { fileName, csvData } = await this.$store.dispatch('analytics/analyticsExport', request)
      const csvFormatData = csvData.map((row) => Object.values(row).join(',')).join('\n')
      const blob = new Blob(['\uFEFF', csvFormatData], {
        type: 'text/csv;charset=utf-8;',
      })

      const url = window.URL.createObjectURL(blob)
      const date = `${this.filterDateRange[0]} 至 ${this.filterDateRange[1]}`
      let productTitle = ''
      let categoryTitle = ''
      let sizetitle = ''


      if (this.fetchDataParams.productId) {
        productTitle = this.merchantProducts.find((item) => {
          return item.id === this.fetchDataParams.productId
        }).name
        productTitle = ` ${productTitle}`
      }
      if (this.fetchDataParams.petCategoryId) {
        categoryTitle = this.categoryList.find((item) => {
          return item.id === this.fetchDataParams.petCategoryId
        }).categoryTitle
        categoryTitle = ` ${categoryTitle}`
      }
      if (this.fetchDataParams.petSizeId) {
        sizetitle = this.activeSizeList.find((item) => {
          return item.id === this.fetchDataParams.petSizeId
        }).title
        sizetitle = ` ${sizetitle}`
      }
      const filterFileName = `${fileName} ( ${date}${productTitle}${categoryTitle}${sizetitle} ).csv`
      const tempLink = document.createElement('a')
      tempLink.download = filterFileName
      tempLink.href = url
      tempLink.click()
      window.URL.revokeObjectURL(url)
      this.tryingToExport = false
    },
    quickSelectTime(unit) {
      if (unit === 'day') {
        const end = new Date()
        const start = new Date()
        this.filterDateRange = [start, end]
      }
      if (unit === 'month') {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
        this.filterDateRange = [start, end]
      }
      this.tryToFetchList()
    }
  },
}
</script>

<template>
  <div :class="$style.page">
    <div class="btn-top-space-between local_topBtn">
      <el-button class="is-round" plain @click="handleExport">
        <BaseIcon name="file-export" /> 訂單匯出
      </el-button>
    </div>
    <BaseTableSearch v-slot="{ fields }" :grow-status="true" :default-value.sync="filterData" hide-action
      class="isForTab2" @reset="reset" @handleExport="handleExport" @tryToFetchList="tryToFetchList"
      reset-btn-style="width:84px;height:44px;">
      <el-form-item prop="status" class="w-full">
        <el-select v-model="fields.productId" placeholder="分店" @change="tryToFetchList">
          <el-option label="全部分店" value></el-option>
          <el-option v-for="(product, index) in merchantProducts" :key="index" :label="product.name"
            :value="product.id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item prop="status" class="w-full" :class="$style.columnShowList">
        <el-select v-model="forShowColumnInSelect" popper-class="isStylecColumnShowList" placeholder="欄位顯示"
          @change="showColumnType">
          <el-option v-for="(column, index) in forShowColumnListFilter" :key="index" :label="column.name"
            :value="column.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="w-full">
        <el-select v-model="fields.petCategoryId" :placeholder="`${$t('reserve.CLIENT')}類別`" @change="tryToFetchList">
          <el-option label="所有類別" value></el-option>
          <el-option v-for="item in categoryList" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="w-full">
        <el-select v-model="filterData.petSizeId" :placeholder="`${$t('reserve.CLIENT')}${$t('member.BODY_TO_TYPE')}`"
          @change="tryToFetchList">
          <el-option :label="`所有${$t('member.BODY_TO_TYPE')}`" value></el-option>
          <template v-if="fields.petCategoryId">

            <el-option v-for="item in activeSizeList" :key="item.id" :label="item.categoryTitle" :value="item.id">
            </el-option>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker v-model="filterDateRange" type="daterange" align="left" unlink-panels range-separator="-"
          start-placeholder="起始日期" end-placeholder="結束日期" :picker-options="pickerOptions" style="width:405px"
          :clearable="false" @change="tryToFetchListFromDatePicker"></el-date-picker>
      </el-form-item>


    </BaseTableSearch>

    <div class="centerTextRadio" :class="$style.bgWhite">
      <h4>銷售紀錄 - {{ showColumnName() }}</h4>
      <div class="right-radio">
        <div class="right-radio" @change="tryToFetchListUnit">
          <el-radio-group v-model="filterData.unit">
            <el-radio-button label="day" :disabled="dateRangeMode === 'year' || dateRangeMode === 'month'">日
            </el-radio-button>
            <el-radio-button label="week" :disabled="dateRangeMode === 'year' || dateRangeMode === 'day'">週
            </el-radio-button>
            <el-radio-button label="month" :disabled="dateRangeMode === 'week' || dateRangeMode === 'day'">月
            </el-radio-button>

            <el-radio-button label="quarter" :disabled="dateRangeMode !== 'year' && dateRangeMode !== ''">季
            </el-radio-button>
            <el-radio-button label="year" :disabled="dateRangeMode !== 'year' && dateRangeMode !== ''">年
            </el-radio-button>
          </el-radio-group>
        </div>
        <el-radio-group v-model="showMode" style="margin-left: 30px" @input="changeShowMode">
          <el-radio-button label="total">顯示金額</el-radio-button>
          <el-radio-button label="orders">顯示數量</el-radio-button>
        </el-radio-group>
      </div>

    </div>

    <div v-if="sales[activeDate]" :class="$style.bgWhite">
      <div v-if="filterData.unit !== 'filterSeason' && filterData.unit !== 'filterYear'" class="timeSelect">
        <div class="timeSelect__arrow" :class="{ disabled: activeDate === dateGroup[0] }" @click="changeGroup(false)">
          <BaseIcon name="angle-left" />
        </div>
        <div class="timeSelect__item isActive">
          {{ activeDate }}
        </div>
        <div class="timeSelect__arrow" :class="{ disabled: activeDate === dateGroup[dateGroup.length - 1] }"
          @click="changeGroup(true)">
          <BaseIcon name="angle-right" />
        </div>
      </div>
    </div>
    <div v-if="sales[activeDate]" :class="$style.bgWhite">
      <div v-if="sales[activeDate].length > 0" class="el-table-wrapper">
        <el-table v-loading="tryingFetchTime" element-loading-text="取得資訊中" :data="sales[activeDate]"
          :summary-method="getSummaries" :show-summary="showSum">
          <el-table-column label="加購項目" min-width="200">
            <template slot-scope="scope"> {{ scope.row.title }}
            </template>
          </el-table-column>
          <el-table-column label="分店" min-width="90">
            <template slot-scope="scope"> {{ scope.row.store }} </template>
          </el-table-column>
          <el-table-column v-for="(item, index) in sales[activeDate][0].items" :key="index" :label="deleteYear(item.date)"
            min-width="150" align="right">
            <template slot-scope="scope"><span v-if="showMode === 'total'">$</span>{{
              scope.row.items[index][forShowColumnInSelect]
            }} </template>
          </el-table-column>
        </el-table>
        <BasePagination ref="pagination" :current-page.sync="currentPage" />
      </div>
      <div v-else>
        <el-alert class="flex-center" title="所選擇的條件與時間內沒有相關數據" type="warning">
        </el-alert>
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
.bottomInfo {
  text-align: center;
  padding: 30px 0;

  :global {
    .bottomInfo {
      &__item {
        padding: 0 10px;
      }
    }
  }
}

.page {
  margin: 20px;
}

.bgWhite {
  background-color: white;
}</style>
